import LocalStorage from './utils/localStorage';

const LIMIT_DEFAULT = 5;
const defaultCacheName = () => `lru-cache-${Math.round(Math.random() * 10000)}`;

interface ILocalStorageLruCache {
  limit?: number;
  name: string;
}

export class LocalStorageLruCache {
  public entries?: Array<string>;

  public limit?: number;

  public name?: string;

  constructor({ limit, name }: ILocalStorageLruCache) {
    this.entries = [];
    this.limit = limit || LIMIT_DEFAULT;
    this.name = name || defaultCacheName();

    const localStorageItems = LocalStorage.getItem(name);
    if (localStorageItems && Array.isArray(localStorageItems)) {
      this.add(...localStorageItems);
    }
  }

  // spread entriesToAdd so we can do cache.add(1, 2, 3, 4)
  add(...entriesToAdd) {
    const entryHashes = new Set();
    // eslint-disable-next-line unicorn/no-array-reduce
    const updatedCache = [...entriesToAdd, ...this.entries].reduce((entries, entry) => {
      if (entryHashes.has(entry) || entries.length >= this.limit) {
        return entries;
      }
      entryHashes.add(entry);
      return [...entries, entry];
    }, []);
    this.save(updatedCache);
  }

  remove(entryToRemove: string) {
    const entryIndex = this.entries.indexOf(entryToRemove);
    if (entryIndex > -1) {
      this.entries.splice(entryIndex, 1);
      this.save(this.entries);
    }
  }

  clear() {
    this.save([]);
  }

  list() {
    return this.entries;
  }

  save(entries) {
    if (entries && Array.isArray(entries)) {
      LocalStorage.setItem(this.name, entries);
      this.entries = entries;
    }
  }
}
